export const IMAGE_TYPES = {
    CROWN : 'crown',
    LEFT : 'left',
    RIGHT : 'right',
}